<template>
  <AnimationComponent>
    <section class="bg-brand-900 py-16 md:py-24">
      <div class="max-w-7xl mx-auto px-8">
        <!-- Heading and Description -->
        <div class="flex flex-col gap-5 items-center max-w-3xl mx-auto mb-16">
          <h2
            class="text-2xl md:text-4xl font-semibold text-white text-center leading-8 md:leading-11 tracking-[-0.02em]"
          >
            {{ title }}
          </h2>
          <p class="text-base md:text-xl text-grey-dark-300 text-center leading-6 md:leading-[30px]">
            {{ description }}
          </p>
        </div>

        <!-- Payment Method Icons -->
        <div class="flex flex-wrap gap-8 items-center justify-center mb-16">
          <div
            v-for="method in paymentMethods"
            :key="method.name"
            class="w-[70px] h-[70px] md:w-24 md:h-24 flex items-center justify-center"
            :class="{
              'bg-white border border-[#d9d9d9] rounded-2xl p-3':
                method.name !== 'Tap to Pay' && method.name !== 'Visa',
            }"
          >
            <img :src="method.imageUrl" :alt="method.name" class="max-w-full max-h-full object-contain" />
          </div>
        </div>

        <!-- CTA Button -->
        <div class="flex justify-center">
          <router-link :to="{ name: linkToPage }">
            <Button size="business" class="w-full md:w-auto">View fees</Button>
          </router-link>
        </div>
      </div>
    </section>
  </AnimationComponent>
</template>

<script setup lang="ts">
import cashIcon from '@/assets/images/business/payment-methods/cash.svg';
import debicheckIcon from '@/assets/images/business/payment-methods/debicheck.png';
import instantEftIcon from '@/assets/images/business/payment-methods/instant-eft.svg';
import mastercardIcon from '@/assets/images/business/payment-methods/mastercard.svg';
import payAtIcon from '@/assets/images/business/payment-methods/pay-at.svg';
import tapToPayIcon from '@/assets/images/business/payment-methods/tap-to-pay.svg';
import visaIcon from '@/assets/images/business/payment-methods/visa.svg';
import { Button } from '@/components/ui/button';
import AnimationComponent from '../AnimationComponent.vue';

interface Props {
  title: string;
  description?: string;
  linkToPage: string;
}

defineProps<Props>();

interface PaymentMethod {
  name: string;
  imageUrl: string;
}

const paymentMethods: PaymentMethod[] = [
  {
    name: 'Visa',
    imageUrl: visaIcon,
  },
  {
    name: 'Mastercard',
    imageUrl: mastercardIcon,
  },
  {
    name: 'Pay@',
    imageUrl: payAtIcon,
  },
  {
    name: 'Cash',
    imageUrl: cashIcon,
  },
  {
    name: 'DebiCheck',
    imageUrl: debicheckIcon,
  },
  {
    name: 'Tap to Pay',
    imageUrl: tapToPayIcon,
  },
  {
    name: 'Instant EFT',
    imageUrl: instantEftIcon,
  },
];
</script>
